export const api = {
    host: 'https://im27ci1n8g.execute-api.eu-central-1.amazonaws.com/v1',
    //host: 'http://edepozyt.pl'
};
